import React from 'react';
import { observer } from 'mobx-react';

export default observer(({ field, type = 'text', placeholder = null }) => (
    <div className="form-field" id={"form-input-" + field.id}>
        <div className="form-field-title">
            <label
                htmlFor={field.id}
                className="f7 db mb2 mt3 light-silver"
            >
                {field.label}
            </label>
        </div>
        <div className="form-field-input" >
            <input
                className="input-reset ba b--black-10 br1 pa2 mb2 db w-100 f6"
                aria-describedby="name-desc"
                {...field.bind({ type, placeholder }) }
            />
            <div className="field-error">
                <small className="f6 db red">
                    {field.error}
                </small>
            </div>
        </div>
    </div>
));



// WEBPACK FOOTER //
// ./src/components/forms/inputs/SimpleInput.jsx